module.exports = __webpack_public_path__ + "assets/7e2770c0326bb9d5cbd98698722a50aa.mp3";